function getApiDomain() {
  var env =
    window.mwcConfig && window.mwcConfig.environment === "development"
      ? "development"
      : "production";

  return env === "development"
    ? "https://dev-api.watchopedia.watch"
    : "https://api.watchopedia.watch";
}

(function () {
  if (window.mwcSaveWatchesInitialized) return;
  window.mwcSaveWatchesInitialized = true;

function mwcGetEdgeDomain() {
  var env =
    window.mwcConfig && window.mwcConfig.environment === "development"
      ? "development"
      : "production";

  return env === "development"
    ? "https://dev-edge." + window.location.host
    : "https://edge." + window.location.host;
}

  function mwcStatus(message) {
    var el = document.getElementById("mwc-save-watch-status");
    if (el) el.textContent = message || "";
  }

  function mwcShowSuccess(show) {
    var el = document.getElementById("mwc-add-watch-success");
    if (!el) return;

    el.style.display = show ? "block" : "none";
  }

  function mwcToggleSuccessActions(show) {
    var el = document.getElementById("mwc-add-watch-success-actions");
    if (!el) return;

    el.style.display = show ? "block" : "none";
  }

  function mwcRenderSuccessSummary(data) {
    var el = document.getElementById("mwc-add-watch-summary");
    if (!el) return;

    var title = ((data.brand || "") + " " + (data.model || "")).trim();
    var reference = data.reference || "";
    var year = data.year || "";
    var photos = Array.isArray(data.photos) ? data.photos : [];
    var image = photos.length ? photos[0] : "";

    var html = '<div style="text-align:center;">';

if (image) {
  html +=
    '<div style="max-width:220px;margin:16px auto;">' +
      '<img src="' + image + '" alt="" style="width:100%;height:auto;display:block;">' +
    '</div>';
}

    html += '<div class="v-stack gap-2" style="margin-top:8px; align-items:center;">';
    html += '<strong>' + title + '</strong>';

    if (reference) {
      html += '<div class="text-sm text-subdued">Reference: ' + reference + '</div>';
    }

    if (year) {
      html += '<div class="text-sm text-subdued">Year: ' + year + '</div>';
    }

    html += '</div>';

    html += '</div>';
    el.innerHTML = html;
    el.style.display = "block";
  }

  function mwcSetButtonState(loading) {
    var btn = document.getElementById("mwc-save-watch-btn");
    if (!btn) return;
    btn.disabled = !!loading;
    btn.textContent = loading ? "Saving..." : "Save Watch";
  }

  async function mwcLoadBrands() {
    var brandEl = document.getElementById("mwc-watch-brand");
    if (!brandEl) return;

    mwcStatus("Loading brands...");

    var res = await fetch(getApiDomain() + "/brands", {
      credentials: "include"
    });

    if (!res.ok) {
      throw new Error("Could not load brands");
    }

    var data = await res.json();

    brandEl.innerHTML = '<option value="">Select brand</option>';

    (Array.isArray(data) ? data : []).forEach(function (item) {
      var option = document.createElement("option");
      option.value = item.brand || "";
      option.textContent = item.brand || "";
      brandEl.appendChild(option);
    });

    mwcStatus("");
  }

  async function mwcLoadModels() {
    var brandEl = document.getElementById("mwc-watch-brand");
    var modelEl = document.getElementById("mwc-watch-model");
    var referenceEl = document.getElementById("mwc-watch-reference");

    if (!brandEl || !modelEl || !referenceEl) return;

    var brand = brandEl.value;

    modelEl.innerHTML = '<option value="">Select model</option>';
    referenceEl.innerHTML = '<option value="">Select reference</option>';
    referenceEl.disabled = true;

    if (!brand) {
      modelEl.disabled = true;
      return;
    }

    modelEl.disabled = true;
    mwcStatus("Loading models...");

    var res = await fetch(
      getApiDomain() + "/models?brand=" + encodeURIComponent(brand),
    { credentials: "include" }
);

    if (!res.ok) {
      throw new Error("Could not load models");
    }

    var data = await res.json();

    (Array.isArray(data) ? data : []).forEach(function (item) {
      var option = document.createElement("option");
      option.value = item.model || "";
      option.textContent = item.model || "";
      modelEl.appendChild(option);
    });

    modelEl.disabled = false;
    mwcStatus("");
  }

  async function mwcLoadReferences() {
    var brandEl = document.getElementById("mwc-watch-brand");
    var modelEl = document.getElementById("mwc-watch-model");
    var referenceEl = document.getElementById("mwc-watch-reference");

    if (!brandEl || !modelEl || !referenceEl) return;

    var brand = brandEl.value;
    var model = modelEl.value;

    referenceEl.innerHTML = '<option value="">Select reference</option>';

    if (!brand || !model) {
      referenceEl.disabled = true;
      return;
    }

    referenceEl.disabled = true;
    mwcStatus("Loading references...");

    var res = await fetch(
  getApiDomain() + "/references?brand=" +
    encodeURIComponent(brand) +
    "&model=" +
    encodeURIComponent(model),
  { credentials: "include" }
);

    if (!res.ok) {
      throw new Error("Could not load references");
    }

    var data = await res.json();

    (Array.isArray(data) ? data : []).forEach(function (item) {
      var option = document.createElement("option");
      option.value = item.id || "";
      option.textContent = item.reference || "";
      referenceEl.appendChild(option);
    });

    referenceEl.disabled = false;
    mwcStatus("");
  }

  document.addEventListener("change", function (event) {
    if (event.target && event.target.id === "mwc-watch-brand") {
      mwcLoadModels();
    }

    if (event.target && event.target.id === "mwc-watch-model") {
      mwcLoadReferences();
    }
  });

document.addEventListener("mwc:authenticated", function () {
  mwcLoadBrands();
});

async function mwcUploadPhotos() {
  var photosEl = document.getElementById("mwc-watch-photos");
  var files = photosEl && photosEl.files ? photosEl.files : [];
  var urls = [];

  if (!files.length) return urls;

  for (var i = 0; i < files.length; i++) {
    var file = files[i];

    var form = new FormData();
    form.append("file", file);

    var res = await fetch(getApiDomain() + "/upload-photo", {
  method: "POST",
  body: form,
  credentials: "include"
});

    if (!res.ok) {
      throw new Error("Upload failed");
    }

    var data = await res.json();
    if (data && data.url) {
      urls.push(data.url);
    }
  }

  return urls;
}

async function mwcSaveWatch() {
  var brandEl = document.getElementById("mwc-watch-brand");
  var modelEl = document.getElementById("mwc-watch-model");
  var referenceEl = document.getElementById("mwc-watch-reference");
  var yearEl = document.getElementById("mwc-watch-year");

  if (!brandEl || !modelEl || !referenceEl || !yearEl) return;

  var brand = brandEl.value;
  var model = modelEl.value;
  var watch_id = referenceEl.value || null;
var reference = null;

if (watch_id) {
  reference = referenceEl.options[referenceEl.selectedIndex].text || null;
}
  var year = yearEl.value;

  if (!brand || !model) {
    mwcStatus("Select brand and model");
    return;
  }

  try {
    mwcSetButtonState(true);
    mwcStatus("Saving...");

    var photos = await mwcUploadPhotos();

var saved = await MWC.request(mwcGetEdgeDomain() + "/add-watch", {
  method: "POST",
  body: JSON.stringify({
    watch_id: watch_id,
    brand: brand,
    model: model,
    reference: reference || null,
    year: year || null,
    photos: photos
  })
});

document.dispatchEvent(
  new CustomEvent("mwc:watch-added", {
    detail: saved
  })
);

  var formEl = document.getElementById("mwc-add-watch-form");
  var headingEl = document.getElementById("mwc-add-watch-heading-wrap");

  if (formEl) {
    formEl.style.display = "none";
  }

  if (headingEl) {
    headingEl.style.display = "none";
  }

  mwcStatus("");
  mwcShowSuccess(true);
  mwcToggleSuccessActions(true);
  var detailLink = document.getElementById("mwc-view-watch-detail");
  if (detailLink && saved && saved.id) {
    detailLink.href = "/pages/my-watch?id=" + encodeURIComponent(saved.id);
  }
  mwcRenderSuccessSummary({
    brand: brand,
    model: model,
    reference: reference || null,
    year: year || null,
    photos: photos
  });

  } catch (e) {
    mwcStatus(e.message || "Error");
  } finally {
    mwcSetButtonState(false);
  }
}

document.addEventListener("click", function (event) {
  var btn = event.target.closest("#mwc-save-watch-btn");
  if (btn) {
    mwcSaveWatch();
  }
});

document.addEventListener("click", function (event) {
  var btn = event.target.closest("#mwc-add-another-watch");
  if (!btn) return;

  var formEl = document.getElementById("mwc-add-watch-form");
  var headingEl = document.getElementById("mwc-add-watch-heading-wrap");
  var successEl = document.getElementById("mwc-add-watch-success");
  var summaryEl = document.getElementById("mwc-add-watch-summary");
  var detailLink = document.getElementById("mwc-view-watch-detail");

  var brandEl = document.getElementById("mwc-watch-brand");
  var modelEl = document.getElementById("mwc-watch-model");
  var referenceEl = document.getElementById("mwc-watch-reference");
  var yearEl = document.getElementById("mwc-watch-year");
  var photosEl = document.getElementById("mwc-watch-photos");
  var photoListEl = document.getElementById("mwc-save-watch-photo-list");

  if (headingEl) headingEl.style.display = "block";
  if (formEl) formEl.style.display = "block";

  if (successEl) successEl.style.display = "none";
  if (summaryEl) {
    summaryEl.style.display = "none";
    summaryEl.innerHTML = "";
  }

  mwcToggleSuccessActions(false);
  mwcStatus("");

  if (brandEl) brandEl.value = "";
  if (modelEl) {
    modelEl.innerHTML = '<option value="">Select model</option>';
    modelEl.disabled = true;
  }
  if (referenceEl) {
    referenceEl.innerHTML = '<option value="">Select reference</option>';
    referenceEl.disabled = true;
  }
  if (yearEl) yearEl.value = "";
  if (photosEl) photosEl.value = "";
  if (photoListEl) photoListEl.innerHTML = "";

  if (detailLink) {
    detailLink.href = "/pages/my-watches";
  }

  if (typeof mwcLoadBrands === "function") {
    mwcLoadBrands();
  }
});


})();